<script lang="ts">
    import { Button} from "sveltestrap";
    import { checkout, continueshopping } from "../../../../utils/Constant/Constant";
</script>
<tr>
    <td class="text-end" colspan="5">
        <Button color="secondary" class="cart-btn-transform" href="/ecommerce/product">{continueshopping}</Button>
    </td>
    <td>
        <Button color="success" class="cart-btn-transform" href="/ecommerce/checkout">{checkout}</Button>
    </td>
</tr>